import { Card, Form, message, Radio, Typography, Select } from "antd";
import { useForm } from "antd/es/form/Form";
import { useParams } from "react-router";
import { useEffect } from "react";
import { faqService } from "../../services/faq.service";
import CardFooterAction from "../../components/CardFooterAction";
import { useGetDetailApi, useStoreUpdateApi } from "../../hooks/useApi";
import CustomTextArea from "../../components/CustomTextArea";
import CustomTextInput from "../../components/CustomTextInput";
import { directorateOptions } from "../../data/dummyUser";
import { useMe } from "../../hooks/useMe";

export default function FAQForm() {
  const { id } = useParams();
  const [form] = useForm();
  const [messageApi, messageHolder] = message.useMessage();
  const { data: userDataProfile } = useMe();
  const userDirectorate = userDataProfile?.data?.directorate;
  const userPosition = userDataProfile?.data?.position;

  const { data } = useGetDetailApi({
    id,
    serviceFn: faqService.findById,
    queryKey: ["faq"],
  });

  const { storeMutation, updateMutation } = useStoreUpdateApi({
    service: faqService,
    form: form,
    messageApi: messageApi,
    queryKey: "faq",
    route: "/faq",
  });

  useEffect(() => {
    if (id && data) {
      form.setFieldsValue({
        ...data,
        isPinned: data.isPinned ? "pin" : "unpin",
      });
    }
  }, [form, id, data]);

  const isPending = storeMutation.isPending || updateMutation.isPending;

  const handleSubmit = (values) => {
    if (!id) {
      storeMutation.mutate(values);
    } else {
      updateMutation.mutate({ id, data: values });
    }
  };

  return (
    <>
      {messageHolder}
      <Card
        title={(id ? "Ubah" : "Tambah") + " FAQ"}
        actions={[
          <CardFooterAction
            key={"1"}
            route={"/faq"}
            onClick={() => form.submit()}
            loading={isPending}
          />,
        ]}
      >
        <Form
          initialValues={{
            directorate:
              userPosition?.toLowerCase() === "superadmin"
                ? undefined
                : userDirectorate == "Direktorat Vokasi"
                  ? userDirectorate
                  : "Direktorat Peningkatan Kapasitas",
            isPinned: "pin",
          }}
          layout="vertical"
          form={form}
          onFinish={handleSubmit}
        >
          <Form.Item
            name={"directorate"}
            label={
              <Typography.Text>
                Direktorat
                <Typography.Text style={{ color: "#940808" }}>
                  *
                </Typography.Text>
              </Typography.Text>
            }
            required={false}
            rules={[
              {
                required: true,
                message: "Direktorat harus diisi",
              },
            ]}
          >
            <Select
              size="large"
              options={directorateOptions}
              disabled={userPosition?.toLowerCase() !== "superadmin"}
            />
          </Form.Item>

          <CustomTextInput
            label="Pertanyaan"
            name="question"
            rules={[{ required: true, message: "Pertanyaan harus diisi" }]}
            disabled={isPending}
          />

          <CustomTextArea
            label="Jawaban"
            name="answer"
            rules={[
              { required: true, message: "Jawaban harus diisi" },
              { max: 500, message: "Maksimal 500 karakter" },
            ]}
            showCharCount={true}
            disabled={isPending}
          />

          <Form.Item
            name={"isPinned"}
            label={
              <Typography.Text>
                Pin ke beranda
                <Typography.Text style={{ color: "#940808" }}>
                  *
                </Typography.Text>
              </Typography.Text>
            }
            required={false}
            rules={[
              {
                required: true,
                message: "Status harus dipilih",
              },
            ]}
          >
            <Radio.Group>
              <Radio style={{ marginRight: 80 }} value={"pin"}>
                Ya
              </Radio>
              <Radio value={"unpin"}>Tidak</Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
      </Card>
    </>
  );
}
